import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Discover Our Interior Design Services"} subTitle={"Transform Your Space with Style"} linear sideHeading />
        <Button link={"Services"} title={"View Services"} />

      </div>
    </section>
  );

};

export default Banner;